import styled from 'styled-components';

export const PageContainer = styled.div`
  ul {
    margin: 0 auto;
    padding: 0;
    list-style-type: none;
  }

  img {
    max-width: 100%;
  }

  min-height: 200px;
  margin-top: 20px;

  ${({ $brand }) => $brand == 'jackson' && `
    margin-bottom: 0px;
    padding-bottom: 0;
  `}
`;

export const ContentContainer = styled.div`
  max-width: ${({ maxWidth }) => maxWidth ? maxWidth : '1376px'};
  margin: 0 auto;
  padding: 0 16px;
`;

export const Button = styled.button`
  width: 100%;
  padding: 12px 24px;
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  border-radius: 3px;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1;
  letter-spacing: 0em;
  text-transform: uppercase;
  color: #666;
  -webkit-font-smoothing: antialiased;
  transition: background-color 150ms ease;
  opacity: ${({ $inactive }) => $inactive == false ? 0.5 : 1};
  pointer-events: ${({ $inactive }) => $inactive == false ? 'none' : 'all'};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 8px;
    vertical-align: middle;
  }
  
  ${({ theme }) => theme == 'success' && `
    background-color: #2ac278;
    color: #fff;
    border: none;

    &:hover {
      background-color: #23a063;
    }
  `}

  ${({ theme }) => theme == 'brand' && `
    background-color: #d52b1e;
    color: #fff;
    border: none;

    &:hover {
      color: #fff;
      background-color: #b12419;
    }
  `}

  ${({ theme }) => theme == 'transparent' && `
    background-color: transparent;
    border: none;
  `}

  @media (min-width: 768px) {
    width: initial;
  }

  ${({ theme }) => (typeof theme == 'string' && theme.toLowerCase().includes('fender')) && `
    background-color: #d52b1e;
    border: none;
  `}

  ${({ theme }) => (typeof theme == 'string' && theme.toLowerCase().includes('jackson')) && `
    background-color: #287104 !important;
    color: #fff;
    border: none;
    border-radius: 0;
  `}

  ${({ theme }) => (typeof theme == 'string' && theme.toLowerCase().includes('presonus')) && `
    background-color: #0083FF !important;
    color: #fff;
    border: none;
  `}
`;

export const ButtonDark = styled.button`
  width: 100%;
  padding: 12px 24px;
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  border-radius: 3px;
  text-align: center;
  line-height: 1;
  letter-spacing: 0em;
  text-transform: uppercase;
  color: #666;
  -webkit-font-smoothing: antialiased;
  transition: background-color 150ms ease;
  opacity: ${({ $inactive }) => $inactive == false ? 0.5 : 1};
  pointer-events: ${({ $inactive }) => $inactive == false ? 'none' : 'all'};
  border-radius: 100px;
  font-size: 0.875rem;
  transition: all .3s ease-in-out;
  background: #000;
  border: 1px solid #000;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 8px;
    vertical-align: middle;
  }

  &:hover {
    background-color: transparent;
    border: 1px solid #000;
    color: #000;
  }

  ${({ theme }) => theme == 'success' && `
    background-color: #2ac278;
    color: #fff;
    border: none;

    &:hover {
      background-color: #23a063;
    }
  `}

  ${({ theme }) => theme == 'brand' && `
    background-color: #d52b1e;
    color: #fff;
    border: none;

    &:hover {
      color: #fff;
      background-color: #b12419;
    }
  `}

  ${({ theme }) => theme == 'transparent' && `
    background-color: transparent;
    border: none;
  `}

  @media (min-width: 768px) {
    width: initial;
  }

  ${({ theme }) => (typeof theme == 'string' && theme.toLowerCase().includes('fender')) && `
  background-color: #000;
  border: 1px solid #000;
  color: #fff;

  &:hover {
    color: #fff;
    background-color: #000;
  }
`}

  ${({ theme }) => theme && theme.toLowerCase().includes('jackson') && `
    background-color: #010101;
    color: #fff;
    border: none;
    border-radius: 0;
    text-transform: uppercase;
    font-family: "Palanquin Dark", sans-serif;

    &:hover {
      color: #fff;
      background-color: #000;
    }
  `}

  ${({ theme }) => (typeof theme == 'string' && theme.toLowerCase().includes('presonus')) && `
  background-color: #1A1B1B;
  color: #fff;
  border: 1px solid #1A1B1B;
  &:hover {
    color: #fff;
    background-color: #000;
  }
  `}
`;

export const ButtonOutlineModal = styled.button`
  width: 100% !important;
  padding: 15px 24px;
  background: #fff;
  border: 1px solid #121212;
  border-radius: 100px;
  text-align: center;
  font-size: 0.875rem;
  letter-spacing: 0.1rem;
  line-height: 1;
  color: #121212;
  -webkit-font-smoothing: antialiased;
  transition: all 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ $inactive }) => ($inactive == false ? 0.5 : 1)};
  pointer-events: ${({ $inactive }) => ($inactive == false ? 'none' : 'all')};
  cursor: pointer;

  svg {
    margin-right: 8px;
    vertical-align: middle;
  }

  &:hover {
    color: #fff;
    background-color: #121212;
    border-color: #121212;
  }

  ${({ theme }) => theme == 'success' && `
    background-color: #2ac278;
    color: #fff;
    border: none;

    &:hover {
      background-color: #23a063;
    }
  `}

  ${({ theme }) => theme == 'brand' && `
    background-color: #d52b1e;
    color: #fff;
    border: none;

    &:hover {
      color: #fff;
      background-color: #b12419;
    }
  `}

  ${({ theme }) => theme == 'transparent' && `
    background-color: transparent;
    border: none;
  `}

  @media (min-width: 768px) {
    width: initial;
  }

  ${({ theme }) => (typeof theme == 'string' && theme.toLowerCase().includes('fender')) && `
  background-color: transparent;
  border: 1px solid #000;

  &:hover {
    color: #fff;
    background-color: #000;
  }
`}

  ${({ theme }) => (typeof theme == 'string' && theme.toLowerCase().includes('jackson')) && `
    background-color: transparent;
    color: #010101;
    border: 1px solid #010101;
    border-radius: 0;
    font-family: "Palanquin Dark", sans-serif;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.86px;
    line-height: 17.5px;
    text-transform: uppercase;
    margin-top: 12px;
    white-space: nowrap;

    &:hover {
      color: #f1f1f1;
      background-color: #010101;
    }
  `}

  ${({ theme }) => (typeof theme == 'string' && theme.toLowerCase().includes('presonus')) && `
    justify-content: end;
    background-color: transparent;
    color: #000;
    border-radius: 0;
    border: 0;
    font-family: 'HelveticaNowDisplay';
    font-size: 14px;
    letter-spacing: 0;
    line-height: 22px;
    min-height: 100%;
    padding: 0;
    padding-right: 24px;
    text-decoration-line: underline;
    transition: 0.2s all ease;

    &:hover {
        background-color: transparent;
        text-decoration: none;
        color: #000;
    }
  `}
`;

export const ButtonOutline = styled.button`
  width: 100%;
  min-width: 100px;
  padding: 12px 24px;
  background: #fff;
  border: 1px solid #121212;
  border-radius: 100px;
  text-align: center;
  font-size: 0.875rem;
  letter-spacing: 0.1rem;
  line-height: 1;
  color: #121212;
  -webkit-font-smoothing: antialiased;
  transition: all 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ $inactive }) => ($inactive == false ? 0.5 : 1)};
  pointer-events: ${({ $inactive }) => ($inactive == false ? 'none' : 'all')};
  cursor: pointer;

  svg {
    margin-right: 8px;
    vertical-align: middle;
  }

  &:hover {
    color: #fff;
    background-color: #121212;
    border-color: #121212;
  }

  ${({ theme }) => theme == 'success' && `
    background-color: #2ac278;
    color: #fff;
    border: none;

    &:hover {
      background-color: #23a063;
    }
  `}

  ${({ theme }) => theme == 'brand' && `
    background-color: #d52b1e;
    color: #fff;
    border: none;

    &:hover {
      color: #fff;
      background-color: #b12419;
    }
  `}

  ${({ theme }) => theme == 'transparent' && `
    background-color: transparent;
    border: none;
  `}

  @media (min-width: 768px) {
    width: initial;
  }

  ${({ theme }) => (typeof theme == 'string' && theme.toLowerCase().includes('fender')) && `
  background-color: transparent;
  border: 1px solid #000;

  &:hover {
    color: #fff;
    background-color: #000;
  }
`}

  ${({ theme }) => (typeof theme == 'string' && theme.toLowerCase().includes('jackson')) && `
  background-color: transparent;
  color: #000;
  border: 1px solid #000;
  border-radius: 0;

  &:hover {
    color: #fff;
    background-color: #000;
  }
  `}

  ${({ theme }) => (typeof theme == 'string' && theme.toLowerCase().includes('presonus')) && `
  background-color: transparent;
  color: #000;
  border: 1px solid #000;

  &:hover {
    color: #fff;
    background-color: #000;
  }
  `}
`;

export const BodyText = styled.p`
  font-size: 1.875rem;
  line-height: 24px;
  margin-bottom: 16px;

  span {
    color: #038cca;
    cursor: pointer;
  }
`;

export const Flex = styled.div`
  display: flex;
  ${({ align }) => align && `align-items: ${align}`};
  ${({ justify }) => justify && `justify-content: ${justify}`};
`;

export const ExpandedModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000 !important;
`;

export const ModalContent= styled.div``

export const ModalBackDrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
  z-index: 1000 !important;
`;

export const StyledChildrenContainer = styled.div`
  background-color: white;
  padding: 20px;
  opacity: 1;
  z-index: 1000;
  position: relative;
  width: 90%;
  height: 95%;

  @media screen and (min-width: 768px) {
    width: 80%;
    height: 72.5%;
  }
`;

export const StyledLabel = styled.label`
  // display: ${({ visible }) => (visible ? 'block' : 'none')};
  display: none;
  color: #666;
  font-size: 16px;
  margin: 16px 0 4px;
  transition: opacity 0.3s ease;
`;

export const StyledInput = styled.input`
  width: 100%;
  margin: 0;
  padding: 19px 16px;
  appearance: none;

  flex-shrink: 0;
  border-radius: 16px;
  border: 1px solid #EAEAEA;
  background: #FFF;
  color: #1A1B1B;
  font-family: "HelveticaNowDisplay";
  font-size: 14px;
  font-style: normal;
  line-height: 22px;

  &:focus {
    outline: none;
    box-shadow: none;
  }
`;

export const ButtonLink = styled.button`
	margin: 0 auto;
	border: none;
	padding: 0;
	background: none;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
  `;